import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function StrategicPartnerDetails() {
    return (
        <div>
            <PageSeo title="HSBC Innovation Banking | The Gender Index" pathname={ROUTES.headlinePartnershsbc} />
            <Layout>

                <div className='singleLayout partnerDetailsPage'>
                    <div className='edgeBannerWrapper'>
                        <div className='edgeBanner'>
                        </div>
                        <div className="bannerDetailsWrap">
                            <div className="leftPane">
                                <Link className="backBtn" href="/headline-partners">&lt; Back</Link>
                                <h4>Headline partner</h4>
                                <h1>HSBC Innovation Banking</h1>
                                <ul className="commonList link">
                                    <li><a href="http://www.hsbcinnovationbanking.com/" target="_blank" rel="noreferrer">www.HSBCInnovationBanking.com</a></li>
                                    <li><a href="https://www.linkedin.com/company/hsbc-innovation/" target="_blank" rel="noreferrer">www.linkedin.com/company/hsbc-innovation/</a></li>
                                    <li>@HSBC</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="logo-image hsbc">
                        {/* <img src="/images/PartnerLogos/svb-new.png" alt="logo_image" /> */}
                        <Image
                            src="/images/PartnerLogos/hsbc.png"
                            alt="logo_image"
                            width={232}
                            height={50}
                            loading="lazy"
                        />
                    </div>
                    <p className='body-default-copy-large'>As a committed, long-term partner to the innovation economy, we offer more than commercial banking services. We have
                        the expertise, agility and connections that high-growth technology, private equity, and venture capital businesses need to
                        accelerate.</p>
                    <h6>Why HSBC Innovation Banking is supporting The Gender Index:</h6>
                    <p className='body-default-copy-large'>As the financial partner to the innovation economy, we know that innovation needs different ideas, technologies, and
                        voices to reshape our world.</p>
                    <p className='body-default-copy-large'>We also know that there are invaluable perspectives that are still being overlooked.</p>
                    <p className='body-default-copy-large'>We support The Gender Index because we know the power of, and need for, transparency about the reality facing the full
                        spectrum of innovators. We firmly believe that what is known and measured can be changed. That’s why a clear, objective
                        picture of the reality of the UK’s female business community is so important. Not only does it encourage the entire
                        innovation community to reflect on progress made, but also, to identify opportunities to improve gender equality and
                        access to finance and helpful resources.</p>
                    <p className='body-default-copy-large'>Said simply, we support The Gender Index because it is a means to inspire change and ensure that initiatives have the
                        required impact.</p>
                    <h6>HSBC Innovation Banking’s programmes and initiatives to support female entrepreneurs:</h6>
                    <p className='body-default-copy-large'>There are two foundations that underpin our efforts to support female entrepreneurs.</p>
                    <p className='body-default-copy-large'>The first is the partnerships that we have built with external partners and platforms like The Gender Index. With a focus on
actionable insight and sharing transparent, objective data, our work with organisations like Diversity VC, Extend Ventures,
European Women in VC and Female Foundry is focused on measurement, and holding ourselves and our community
accountable by empowering them to set realistic targets.</p>
                    <p className='body-default-copy-large'>The second aspect is change from within. Our DEI strategy consists of 15 key initiatives clustered around Talent,
Inclusion, and the Ecosystem, and is built to help our clients, partners, and ecosystem to evolve.</p>
                    <p className='body-default-copy-large'>From clear leadership representation targets to our dynamic Employee Resource Groups, we are set up for active
advocacy which we’re committed to bringing to every part of our network.</p>
                    {/* <div className="flex">
                        <h6 className="mr8">Website:</h6>
                        <a className="linkText" href="www.sbv.com/uk" target="_blank">www.sbv.com/uk</a>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">Twitter:</h6>
                        <span>@SVB_UK</span>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">LinkedIn:</h6>
                        <a className="linkText" href="www.sbv.com/uk" target="_blank">www.sbv.com/uk</a>
                    </div> */}
                </div>
            </Layout >
        </div >
    );
}

